import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state= {
    email: '',
    menuClickParam: '',
    menuPath: '',
    menuPathKeys: ''
}

const mutations = {
    setEmail(state,newEmail) {
        state.email = newEmail;
    },
    setMenuClickParam(state,newMenuClickParam) {
        state.menuClickParam = newMenuClickParam;
    },
    setMenuPath(state,newMenuPath) {
        state.menuPath = newMenuPath;
    },
    setMenuPathKeys(state,newMenuPathKeys) {
        state.menuPathKeys = newMenuPathKeys;
    },
}

const actions = {

}

const getters = {

}

export default new Vuex.Store( {
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js